// eslint-disable-next-line import/prefer-default-export
export const RIGHTS = 'rights';
export const UID = 'uid';
export const COMPANY_SECTIONS_RIGHTS = 'companySectionsRights';
